import * as types from "./types";

export function fetchIRRecoveryPointsStart(clientUUID, restore) {
  return {
    type: types.FETCH_IR_RECOVERY_POINTS_START,
    clientUUID,
    restoreType: restore.type,
    scheduleUUID: restore.scheduleUUID,
    params: {
      onMount: restore.onMount,
      serverIPAddress: restore.serverIPAddress
    }
  };
}

export function fetchIRRecoveryPointsSuccess(points, params) {
  return {
    type: types.FETCH_IR_RECOVERY_POINTS_SUCCESS,
    points,
    params
  };
}

export function fetchIRRecoveryPointsFailure(data, params) {
  return {
    type: types.FETCH_IR_RECOVERY_POINTS_FAILURE,
    data,
    params
  };
}

export function changeIRRecoveryPoint(scheduleUUID) {
  return {
    type: types.CHANGE_IR_RECOVERY_POINT,
    scheduleUUID
  };
}

export function updateIRRecoveryPointSuccess(points) {
  return {
    type: types.UPDATE_IR_RECOVERY_POINT_SUCCESS,
    points
  };
}

export function clearImageRestore() {
  return {
    type: types.CLEAR_IMAGE_RESTORE
  };
}

export function machineOfflineIR() {
  return {
    type: types.MACHINE_OFFLINE_IR
  };
}

export function storeIRRequestParams(params) {
  return {
    type: types.STORE_IR_REQUEST_PARAMS,
    params
  };
}

export function fetchUpdatedVolumes(clientUUID, sourceClientUUID) {
  return {
    type: types.FETCH_UPDATED_VOLUMES,
    clientUUID,
    sourceClientUUID
  };
}

export function populateUpdatedVolumes(client) {
  return {
    type: types.POPULATE_UPDATED_VOLUMES,
    client
  };
}

export function toggleVolumeImageRestore(deviceId, volumeId) {
  return {
    type: types.TOGGLE_VOLUME_IMAGE_RESTORE,
    deviceId,
    volumeId
  };
}

export function changeTargetVolume(deviceId, volumeId, targetVol) {
  return {
    type: types.CHANGE_TARGET_VOLUME,
    deviceId,
    volumeId,
    targetVol
  };
}
export function initiateImageRestore(data) {
  return {
    type: types.INITIATE_IMAGE_RESTORE,
    data
  };
}

export function changeIRTargetMachine(client) {
  return {
    type: types.CHANGE_IMAGE_RESTORE_TARGET_MACHINE,
    client
  };
}
